import type Notification from "@/classes/Notification.ts";
import { useNotifications } from "@/stores/notifications.ts";

export default (notification: Notification) => {
  const notifications = useNotifications();

  notifications.push(notification);
};
